@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_150_911_368)
internal val Res.string.exp_content_possessivo_suffisso_11: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_11", "exp_content_possessivo_suffisso_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 99478, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 98402, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 101071, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 94726, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92138, 118),
      ))
    }

@delegate:ResourceContentHash(85_967_260)
internal val Res.string.exp_content_possessivo_suffisso_12: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_12", "exp_content_possessivo_suffisso_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 99601, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 98529, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 101194, 150),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 94837, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92257, 130),
      ))
    }

@delegate:ResourceContentHash(354_399_013)
internal val Res.string.exp_content_possessivo_suffisso_13: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_13", "exp_content_possessivo_suffisso_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 99732, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 98672, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 101345, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 94960, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92388, 110),
      ))
    }

@delegate:ResourceContentHash(1_511_450_195)
internal val Res.string.exp_content_possessivo_suffisso_14: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_14", "exp_content_possessivo_suffisso_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 99843, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 98791, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 101464, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 95083, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92499, 86),
      ))
    }

@delegate:ResourceContentHash(1_042_838_772)
internal val Res.string.exp_content_possessivo_suffisso_15: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_15", "exp_content_possessivo_suffisso_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 99938, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 98878, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 101551, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 95166, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92586, 130),
      ))
    }

@delegate:ResourceContentHash(-327_959_447)
internal val Res.string.exp_content_possessivo_suffisso_16: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_16", "exp_content_possessivo_suffisso_16", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 100077, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 99013, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 101690, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 95297, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92717, 110),
      ))
    }

@delegate:ResourceContentHash(-1_688_880_458)
internal val Res.string.exp_content_possessivo_suffisso_17: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_17", "exp_content_possessivo_suffisso_17", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 100188, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 99144, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 101805, 126),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 95412, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92828, 110),
      ))
    }

@delegate:ResourceContentHash(-83_697_571)
internal val Res.string.exp_content_possessivo_suffisso_18: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_18", "exp_content_possessivo_suffisso_18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 100311, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 99259, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 101932, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 95523, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92939, 94),
      ))
    }

@delegate:ResourceContentHash(1_749_056_727)
internal val Res.string.exp_content_possessivo_suffisso_19: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_19", "exp_content_possessivo_suffisso_19", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 100410, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 99350, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 102039, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 95622, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93034, 74),
      ))
    }

@delegate:ResourceContentHash(379_539_100)
internal val Res.string.exp_content_possessivo_suffisso_2: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_2", "exp_content_possessivo_suffisso_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 100793, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 99713, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 102426, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 95985, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93373, 113),
      ))
    }

@delegate:ResourceContentHash(613_814_852)
internal val Res.string.exp_content_possessivo_suffisso_20: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_20", "exp_content_possessivo_suffisso_20", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 100607, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 99535, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 102244, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 95807, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93211, 86),
      ))
    }

@delegate:ResourceContentHash(1_060_529_775)
internal val Res.string.exp_content_possessivo_suffisso_21: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_21", "exp_content_possessivo_suffisso_21", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 100706, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 99622, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 102335, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 95902, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93298, 74),
      ))
    }

@delegate:ResourceContentHash(1_094_350_087)
internal val Res.string.exp_content_possessivo_suffisso_3: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_3", "exp_content_possessivo_suffisso_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 100911, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 99831, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 102548, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 96099, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93487, 113),
      ))
    }

@delegate:ResourceContentHash(-1_146_978_816)
internal val Res.string.exp_content_possessivo_suffisso_4: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_4", "exp_content_possessivo_suffisso_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 101037, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 99941, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 102682, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 96221, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93601, 73),
      ))
    }

@delegate:ResourceContentHash(759_986_350)
internal val Res.string.exp_content_possessivo_suffisso_5: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_5", "exp_content_possessivo_suffisso_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 101119, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 100019, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 102764, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 96291, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93675, 113),
      ))
    }

@delegate:ResourceContentHash(-619_639_592)
internal val Res.string.exp_content_possessivo_suffisso_6: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_6", "exp_content_possessivo_suffisso_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 101245, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 100145, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 102882, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 96409, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93789, 113),
      ))
    }

@delegate:ResourceContentHash(-1_030_934_374)
internal val Res.string.exp_content_possessivo_suffisso_7: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_7", "exp_content_possessivo_suffisso_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 101379, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 100267, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 103004, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 96527, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93903, 65),
      ))
    }

@delegate:ResourceContentHash(-1_487_927_942)
internal val Res.string.exp_content_possessivo_suffisso_8: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_8", "exp_content_possessivo_suffisso_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 101445, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 100333, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 103074, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 96597, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93969, 105),
      ))
    }

@delegate:ResourceContentHash(-2_103_793_575)
internal val Res.string.exp_content_possessivo_suffisso_9: StringResource by lazy {
      StringResource("string:exp_content_possessivo_suffisso_9", "exp_content_possessivo_suffisso_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 101555, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 100431, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 103176, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 96695, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94075, 65),
      ))
    }

@delegate:ResourceContentHash(-1_536_402_162)
internal val Res.string.exp_content_prendiamo_ad_esempio_la_frase_n_il_vino_del_p: StringResource by
    lazy {
      StringResource("string:exp_content_prendiamo_ad_esempio_la_frase_n_il_vino_del_p", "exp_content_prendiamo_ad_esempio_la_frase_n_il_vino_del_p", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 101621, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 100505, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 103254, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 96777, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94141, 141),
      ))
    }

@delegate:ResourceContentHash(-1_950_494_567)
internal val Res.string.exp_content_preposizione_dr_1: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_1", "exp_content_preposizione_dr_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 102244, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 101120, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 103873, 165),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 97372, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94720, 129),
      ))
    }

@delegate:ResourceContentHash(358_292_050)
internal val Res.string.exp_content_preposizione_dr_10: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_10", "exp_content_preposizione_dr_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 101763, 134),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 100639, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 103392, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 96911, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94283, 126),
      ))
    }

@delegate:ResourceContentHash(2_069_704_931)
internal val Res.string.exp_content_preposizione_dr_11: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_11", "exp_content_preposizione_dr_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 101898, 226),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 100778, 210),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 103515, 226),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 97034, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94410, 194),
      ))
    }

@delegate:ResourceContentHash(-1_683_221_953)
internal val Res.string.exp_content_preposizione_dr_12: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_12", "exp_content_preposizione_dr_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 102125, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 100989, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 103742, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 97253, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94605, 114),
      ))
    }

@delegate:ResourceContentHash(317_139_697)
internal val Res.string.exp_content_preposizione_dr_2: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_2", "exp_content_preposizione_dr_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 102422, 161),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 101278, 181),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 104039, 193),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 97518, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94850, 173),
      ))
    }

@delegate:ResourceContentHash(-1_712_888_129)
internal val Res.string.exp_content_preposizione_dr_3: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_3", "exp_content_preposizione_dr_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 102584, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 101460, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 104233, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 97676, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95024, 105),
      ))
    }

@delegate:ResourceContentHash(1_626_891_753)
internal val Res.string.exp_content_preposizione_dr_4: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_4", "exp_content_preposizione_dr_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 102694, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 101570, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 104363, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 97782, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95130, 101),
      ))
    }

@delegate:ResourceContentHash(1_686_285_253)
internal val Res.string.exp_content_preposizione_dr_5: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_5", "exp_content_preposizione_dr_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 102824, 217),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 101672, 185),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 104473, 197),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 97880, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95232, 181),
      ))
    }

@delegate:ResourceContentHash(-2_139_508_328)
internal val Res.string.exp_content_preposizione_dr_6: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_6", "exp_content_preposizione_dr_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 103042, 181),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 101858, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 104671, 173),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 98070, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95414, 149),
      ))
    }

@delegate:ResourceContentHash(-1_923_685_814)
internal val Res.string.exp_content_preposizione_dr_7: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_7", "exp_content_preposizione_dr_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 103335, 205),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 102127, 201),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 104968, 233),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 98323, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95675, 189),
      ))
    }

@delegate:ResourceContentHash(-1_486_190_897)
internal val Res.string.exp_content_preposizione_dr_7_zeta: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_7_zeta", "exp_content_preposizione_dr_7_zeta", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 103224, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 102020, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 104845, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 98224, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95564, 110),
      ))
    }

@delegate:ResourceContentHash(1_286_368_323)
internal val Res.string.exp_content_preposizione_dr_8: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_8", "exp_content_preposizione_dr_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 103541, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 102329, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 105202, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 98517, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95865, 137),
      ))
    }

@delegate:ResourceContentHash(919_064_552)
internal val Res.string.exp_content_preposizione_dr_9: StringResource by lazy {
      StringResource("string:exp_content_preposizione_dr_9", "exp_content_preposizione_dr_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 103687, 185),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 102471, 189),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 105356, 217),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 98651, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96003, 173),
      ))
    }

@delegate:ResourceContentHash(1_488_876_536)
internal val Res.string.exp_content_preposizione_hr_1: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_1", "exp_content_preposizione_hr_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 104460, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 103212, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 106185, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 99376, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96700, 49),
      ))
    }

@delegate:ResourceContentHash(1_126_516_196)
internal val Res.string.exp_content_preposizione_hr_10: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_10", "exp_content_preposizione_hr_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 103873, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 102661, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 105574, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 98833, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96177, 70),
      ))
    }

@delegate:ResourceContentHash(-1_563_436_858)
internal val Res.string.exp_content_preposizione_hr_11: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_11", "exp_content_preposizione_hr_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 103952, 150),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 102740, 146),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 105649, 162),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 98908, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96248, 130),
      ))
    }

@delegate:ResourceContentHash(1_353_158_783)
internal val Res.string.exp_content_preposizione_hr_12: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_12", "exp_content_preposizione_hr_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 104103, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 102887, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 105812, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 99047, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96379, 70),
      ))
    }

@delegate:ResourceContentHash(-899_861_920)
internal val Res.string.exp_content_preposizione_hr_13: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_13", "exp_content_preposizione_hr_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 104178, 182),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 102962, 162),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 105891, 194),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 99122, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96450, 162),
      ))
    }

@delegate:ResourceContentHash(1_382_404_465)
internal val Res.string.exp_content_preposizione_hr_14: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_14", "exp_content_preposizione_hr_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 104361, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 103125, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 106086, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 99285, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96613, 86),
      ))
    }

@delegate:ResourceContentHash(2_073_490_836)
internal val Res.string.exp_content_preposizione_hr_2: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_2", "exp_content_preposizione_hr_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 104510, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 103262, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 106239, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 99430, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96750, 85),
      ))
    }

@delegate:ResourceContentHash(-262_645_943)
internal val Res.string.exp_content_preposizione_hr_3: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_3", "exp_content_preposizione_hr_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 104600, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 103360, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 106329, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 99520, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96836, 49),
      ))
    }

@delegate:ResourceContentHash(-1_945_365_624)
internal val Res.string.exp_content_preposizione_hr_4: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_4", "exp_content_preposizione_hr_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 104646, 193),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 103410, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 106383, 193),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 99570, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96886, 157),
      ))
    }

@delegate:ResourceContentHash(-531_648_466)
internal val Res.string.exp_content_preposizione_hr_5: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_5", "exp_content_preposizione_hr_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 104840, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 103580, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 106577, 177),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 99740, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97044, 141),
      ))
    }

@delegate:ResourceContentHash(1_093_067_343)
internal val Res.string.exp_content_preposizione_hr_6: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_6", "exp_content_preposizione_hr_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 105018, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 103734, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 106755, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 99894, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97186, 113),
      ))
    }

@delegate:ResourceContentHash(796_618_513)
internal val Res.string.exp_content_preposizione_hr_7: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_7", "exp_content_preposizione_hr_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 105132, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 103840, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 106877, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 100008, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97300, 61),
      ))
    }

@delegate:ResourceContentHash(1_264_205_256)
internal val Res.string.exp_content_preposizione_hr_8: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_8", "exp_content_preposizione_hr_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 105198, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 103906, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 106943, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 100066, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97362, 57),
      ))
    }

@delegate:ResourceContentHash(-2_079_352_553)
internal val Res.string.exp_content_preposizione_hr_9: StringResource by lazy {
      StringResource("string:exp_content_preposizione_hr_9", "exp_content_preposizione_hr_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 105260, 173),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 103972, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 107013, 189),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 100124, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97420, 165),
      ))
    }

@delegate:ResourceContentHash(-1_139_824_289)
internal val Res.string.exp_content_preposizione_m_1: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_1", "exp_content_preposizione_m_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 105434, 160),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 104142, 156),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 107203, 180),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 100306, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97586, 140),
      ))
    }

@delegate:ResourceContentHash(-227_106_450)
internal val Res.string.exp_content_preposizione_m_2: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_2", "exp_content_preposizione_m_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 105595, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 104299, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 107384, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 100459, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97727, 128),
      ))
    }

@delegate:ResourceContentHash(-1_724_676_197)
internal val Res.string.exp_content_preposizione_m_3: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_3", "exp_content_preposizione_m_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 105720, 176),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 104416, 164),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 107505, 184),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 100572, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97856, 152),
      ))
    }

@delegate:ResourceContentHash(-994_812_047)
internal val Res.string.exp_content_preposizione_m_4: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_4", "exp_content_preposizione_m_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 105897, 152),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 104581, 136),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 107690, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 100741, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98009, 128),
      ))
    }

@delegate:ResourceContentHash(392_771_672)
internal val Res.string.exp_content_preposizione_m_5: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_5", "exp_content_preposizione_m_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 106050, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 104718, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 107819, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 100866, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98138, 88),
      ))
    }

@delegate:ResourceContentHash(-1_978_738_360)
internal val Res.string.exp_content_preposizione_m_6: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_6", "exp_content_preposizione_m_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 106143, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 104815, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 107936, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 100955, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98227, 116),
      ))
    }

@delegate:ResourceContentHash(-760_530_189)
internal val Res.string.exp_content_preposizione_m_7: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_7", "exp_content_preposizione_m_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 106260, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 104940, 156),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 108073, 172),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 101080, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98344, 156),
      ))
    }

@delegate:ResourceContentHash(-892_962_513)
internal val Res.string.exp_content_preposizione_m_locativa_1: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_1", "exp_content_preposizione_m_locativa_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 107259, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 106003, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 102067, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99331, 109),
      ))
    }

@delegate:ResourceContentHash(-207_698_716)
internal val Res.string.exp_content_preposizione_m_locativa_10: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_10", "exp_content_preposizione_m_locativa_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 106385, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 105097, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 101233, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98501, 110),
      ))
    }

@delegate:ResourceContentHash(665_199_506)
internal val Res.string.exp_content_preposizione_m_locativa_11: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_11", "exp_content_preposizione_m_locativa_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 106504, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 105220, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 101348, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98612, 114),
      ))
    }

@delegate:ResourceContentHash(144_504_877)
internal val Res.string.exp_content_preposizione_m_locativa_12: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_12", "exp_content_preposizione_m_locativa_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 106627, 198),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 105351, 190),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 101475, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98727, 186),
      ))
    }

@delegate:ResourceContentHash(-1_166_695_899)
internal val Res.string.exp_content_preposizione_m_locativa_13: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_13", "exp_content_preposizione_m_locativa_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 106826, 214),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 105542, 218),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 101650, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98914, 198),
      ))
    }

@delegate:ResourceContentHash(-929_083_723)
internal val Res.string.exp_content_preposizione_m_locativa_14: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_14", "exp_content_preposizione_m_locativa_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 107041, 142),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 105761, 162),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 101845, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99113, 142),
      ))
    }

@delegate:ResourceContentHash(613_055_230)
internal val Res.string.exp_content_preposizione_m_locativa_15: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_15", "exp_content_preposizione_m_locativa_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 107184, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 105924, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 101992, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99256, 74),
      ))
    }

@delegate:ResourceContentHash(-260_934_245)
internal val Res.string.exp_content_preposizione_m_locativa_2: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_2", "exp_content_preposizione_m_locativa_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 107397, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 106109, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 102181, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99441, 81),
      ))
    }

@delegate:ResourceContentHash(-1_394_995_658)
internal val Res.string.exp_content_preposizione_m_locativa_3: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_3", "exp_content_preposizione_m_locativa_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 107479, 161),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 106191, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 102263, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99523, 141),
      ))
    }

@delegate:ResourceContentHash(68_715_685)
internal val Res.string.exp_content_preposizione_m_locativa_4: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_4", "exp_content_preposizione_m_locativa_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 107641, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 106349, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 102429, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99665, 69),
      ))
    }

@delegate:ResourceContentHash(-407_665_895)
internal val Res.string.exp_content_preposizione_m_locativa_5: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_5", "exp_content_preposizione_m_locativa_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 107723, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 106431, 173),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 102503, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99735, 169),
      ))
    }

@delegate:ResourceContentHash(-1_870_163_655)
internal val Res.string.exp_content_preposizione_m_locativa_6: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_6", "exp_content_preposizione_m_locativa_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 107889, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 106605, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 102673, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99905, 133),
      ))
    }

@delegate:ResourceContentHash(-1_853_561_746)
internal val Res.string.exp_content_preposizione_m_locativa_7: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_7", "exp_content_preposizione_m_locativa_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 108039, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 106767, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 102827, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100039, 73),
      ))
    }

@delegate:ResourceContentHash(148_991_187)
internal val Res.string.exp_content_preposizione_m_locativa_8: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_8", "exp_content_preposizione_m_locativa_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 108113, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 106841, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 102897, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100113, 121),
      ))
    }

@delegate:ResourceContentHash(571_986_919)
internal val Res.string.exp_content_preposizione_m_locativa_9: StringResource by lazy {
      StringResource("string:exp_content_preposizione_m_locativa_9", "exp_content_preposizione_m_locativa_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 108255, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 106979, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 103027, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100235, 109),
      ))
    }

@delegate:ResourceContentHash(-689_819_626)
internal val Res.string.exp_content_presto_al_prossimo_capitolo: StringResource by lazy {
      StringResource("string:exp_content_presto_al_prossimo_capitolo", "exp_content_presto_al_prossimo_capitolo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 108381, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 107093, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 108246, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 103137, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100345, 87),
      ))
    }

@delegate:ResourceContentHash(-343_667_602)
internal val Res.string.exp_content_prima_del_cartiglio_in_apposizione_si_trova_il_titolo:
    StringResource by lazy {
      StringResource("string:exp_content_prima_del_cartiglio_in_apposizione_si_trova_il_titolo", "exp_content_prima_del_cartiglio_in_apposizione_si_trova_il_titolo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 108485, 253),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 107193, 241),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 108338, 261),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 103225, 229),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100433, 221),
      ))
    }

@delegate:ResourceContentHash(1_676_618_041)
internal val Res.string.exp_content_prima_di_addentrarci_nelle_regole_delle_frasi: StringResource by
    lazy {
      StringResource("string:exp_content_prima_di_addentrarci_nelle_regole_delle_frasi", "exp_content_prima_di_addentrarci_nelle_regole_delle_frasi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 108739, 229),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 107435, 237),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 108600, 221),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 103455, 213),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100655, 197),
      ))
    }

@delegate:ResourceContentHash(1_840_415_028)
internal val Res.string.exp_content_prima_di_imparare_altre_parole_dobbiamo_capir: StringResource by
    lazy {
      StringResource("string:exp_content_prima_di_imparare_altre_parole_dobbiamo_capir", "exp_content_prima_di_imparare_altre_parole_dobbiamo_capir", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 108969, 181),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 107673, 173),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 108822, 177),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 103669, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100853, 169),
      ))
    }

@delegate:ResourceContentHash(206_720_081)
internal val Res.string.exp_content_quando_la_cosa_posseduta_e_singolare_e_maschile_basta:
    StringResource by lazy {
      StringResource("string:exp_content_quando_la_cosa_posseduta_e_singolare_e_maschile_basta", "exp_content_quando_la_cosa_posseduta_e_singolare_e_maschile_basta", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 109151, 221),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 107847, 209),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 109000, 213),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 103839, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101023, 205),
      ))
    }

@delegate:ResourceContentHash(-436_688_556)
internal val Res.string.exp_content_quando_un_segno_usato_come_ideogramma_si_aggi: StringResource by
    lazy {
      StringResource("string:exp_content_quando_un_segno_usato_come_ideogramma_si_aggi", "exp_content_quando_un_segno_usato_come_ideogramma_si_aggi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 109373, 277),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 108057, 241),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 109214, 273),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 104041, 249),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101229, 229),
      ))
    }

@delegate:ResourceContentHash(-1_056_711_779)
internal val Res.string.exp_content_questa_pratica_era_molto_diffusa_come_offerta: StringResource by
    lazy {
      StringResource("string:exp_content_questa_pratica_era_molto_diffusa_come_offerta", "exp_content_questa_pratica_era_molto_diffusa_come_offerta", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 109651, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 108299, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 109488, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 104291, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101459, 141),
      ))
    }

@delegate:ResourceContentHash(-1_553_053_337)
internal val Res.string.exp_content_questa_regola_ti_aiuta_a_leggere_subito_titoli_e_nomi:
    StringResource by lazy {
      StringResource("string:exp_content_questa_regola_ti_aiuta_a_leggere_subito_titoli_e_nomi", "exp_content_questa_regola_ti_aiuta_a_leggere_subito_titoli_e_nomi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 109797, 173),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 108449, 193),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 109638, 197),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 104433, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101601, 173),
      ))
    }

@delegate:ResourceContentHash(1_775_611_555)
internal val Res.string.exp_content_questa_scritta_sulla_mummia_illuminata: StringResource by lazy {
      StringResource("string:exp_content_questa_scritta_sulla_mummia_illuminata", "exp_content_questa_scritta_sulla_mummia_illuminata", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 109971, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 108643, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 109836, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 104611, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101775, 118),
      ))
    }

@delegate:ResourceContentHash(794_518_635)
internal val Res.string.exp_content_questa_volta_sar_un_po_pi_difficile: StringResource by lazy {
      StringResource("string:exp_content_questa_volta_sar_un_po_pi_difficile", "exp_content_questa_volta_sar_un_po_pi_difficile", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 110086, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 108770, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 109971, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 104730, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101894, 115),
      ))
    }

@delegate:ResourceContentHash(1_996_407_465)
internal val Res.string.exp_content_queste_due_parole_ad_esempio_contengono_le_st: StringResource by
    lazy {
      StringResource("string:exp_content_queste_due_parole_ad_esempio_contengono_le_st", "exp_content_queste_due_parole_ad_esempio_contengono_le_st", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 110190, 253),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 108878, 257),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 110083, 265),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 104842, 245),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102010, 237),
      ))
    }

@delegate:ResourceContentHash(2_129_829_028)
internal val Res.string.exp_content_questi_sono_fratelli_snu_e_sorelle_snut: StringResource by
    lazy {
      StringResource("string:exp_content_questi_sono_fratelli_snu_e_sorelle_snut", "exp_content_questi_sono_fratelli_snu_e_sorelle_snut", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 110444, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 109136, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 110349, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 105088, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102248, 123),
      ))
    }

@delegate:ResourceContentHash(-367_027_960)
internal val Res.string.exp_content_questi_sono_fratello_sn_e_sorella_snt: StringResource by lazy {
      StringResource("string:exp_content_questi_sono_fratello_sn_e_sorella_snt", "exp_content_questi_sono_fratello_sn_e_sorella_snt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 110572, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 109260, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 110477, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 105212, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102372, 117),
      ))
    }

@delegate:ResourceContentHash(1_326_557_830)
internal val Res.string.exp_content_questo_permetteva_di_ottimizzare_lo_spazio_a_: StringResource by
    lazy {
      StringResource("string:exp_content_questo_permetteva_di_ottimizzare_lo_spazio_a_", "exp_content_questo_permetteva_di_ottimizzare_lo_spazio_a_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 110690, 245),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 109378, 257),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 110595, 241),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 105334, 261),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102490, 229),
      ))
    }

@delegate:ResourceContentHash(1_879_594_677)
internal val Res.string.exp_content_qui_oltre_a_ty_viene_ripetuto_due_volte_il_si: StringResource by
    lazy {
      StringResource("string:exp_content_qui_oltre_a_ty_viene_ripetuto_due_volte_il_si", "exp_content_qui_oltre_a_ty_viene_ripetuto_due_volte_il_si", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 110936, 181),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 109636, 181),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 110837, 189),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 105596, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102720, 181),
      ))
    }

@delegate:ResourceContentHash(2_138_774_453)
internal val Res.string.exp_content_qui_sempre_per_motivi_artistici_viene_anche_a: StringResource by
    lazy {
      StringResource("string:exp_content_qui_sempre_per_motivi_artistici_viene_anche_a", "exp_content_qui_sempre_per_motivi_artistici_viene_anche_a", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 111118, 245),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 109818, 209),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 111027, 233),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 105774, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102902, 201),
      ))
    }

@delegate:ResourceContentHash(331_839_045)
internal val Res.string.exp_content_qui_stato_usato_il_plurale_normale_ma_il_dopp: StringResource by
    lazy {
      StringResource("string:exp_content_qui_stato_usato_il_plurale_normale_ma_il_dopp", "exp_content_qui_stato_usato_il_plurale_normale_ma_il_dopp", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 111364, 241),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 110028, 197),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 111261, 221),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 105972, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103104, 197),
      ))
    }

@delegate:ResourceContentHash(-206_127_269)
internal val Res.string.exp_content_quindi_il_genitivo_indiretto_cambia_in_base_al: StringResource
    by lazy {
      StringResource("string:exp_content_quindi_il_genitivo_indiretto_cambia_in_base_al", "exp_content_quindi_il_genitivo_indiretto_cambia_in_base_al", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 111606, 214),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 110226, 214),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 111483, 206),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 106174, 210),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103302, 214),
      ))
    }

@delegate:ResourceContentHash(-1_802_964_625)
internal val Res.string.exp_content_recap_frasi_pseudoverbali_1: StringResource by lazy {
      StringResource("string:exp_content_recap_frasi_pseudoverbali_1", "exp_content_recap_frasi_pseudoverbali_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 111821, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 110441, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 111690, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 106385, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103517, 71),
      ))
    }

@delegate:ResourceContentHash(1_747_202_795)
internal val Res.string.exp_content_recap_frasi_pseudoverbali_2: StringResource by lazy {
      StringResource("string:exp_content_recap_frasi_pseudoverbali_2", "exp_content_recap_frasi_pseudoverbali_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 111897, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 110525, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 111770, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 106465, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103589, 103),
      ))
    }

@delegate:ResourceContentHash(-1_279_635_207)
internal val Res.string.exp_content_recap_frasi_pseudoverbali_3: StringResource by lazy {
      StringResource("string:exp_content_recap_frasi_pseudoverbali_3", "exp_content_recap_frasi_pseudoverbali_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 112005, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 110625, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 111878, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 106565, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103693, 107),
      ))
    }

@delegate:ResourceContentHash(1_131_594_772)
internal val Res.string.exp_content_recap_frasi_pseudoverbali_4: StringResource by lazy {
      StringResource("string:exp_content_recap_frasi_pseudoverbali_4", "exp_content_recap_frasi_pseudoverbali_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 112133, 159),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 110741, 163),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 111994, 163),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 106677, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103801, 151),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_recap_frasi_pseudoverbali_5: StringResource by lazy {
      StringResource("string:exp_content_recap_frasi_pseudoverbali_5", "exp_content_recap_frasi_pseudoverbali_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 112293, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 110905, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 112158, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 106841, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103953, 55),
      ))
    }

@delegate:ResourceContentHash(-1_571_600_069)
internal val Res.string.exp_content_recap_frasi_pseudoverbali_6: StringResource by lazy {
      StringResource("string:exp_content_recap_frasi_pseudoverbali_6", "exp_content_recap_frasi_pseudoverbali_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 112349, 183),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 110965, 179),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 112218, 175),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 106897, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104009, 155),
      ))
    }

@delegate:ResourceContentHash(-204_111_702)
internal val Res.string.exp_content_recap_frasi_pseudoverbali_7: StringResource by lazy {
      StringResource("string:exp_content_recap_frasi_pseudoverbali_7", "exp_content_recap_frasi_pseudoverbali_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 112533, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 111145, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 112394, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 107077, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104165, 111),
      ))
    }

@delegate:ResourceContentHash(229_662_368)
internal val Res.string.exp_content_recap_frasi_pseudoverbali_8: StringResource by lazy {
      StringResource("string:exp_content_recap_frasi_pseudoverbali_8", "exp_content_recap_frasi_pseudoverbali_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 112645, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 111253, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 112502, 159),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 107181, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104277, 139),
      ))
    }

@delegate:ResourceContentHash(814_018_089)
internal val Res.string.exp_content_recap_imperfettivo_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_recap_imperfettivo_alyn_1", "exp_content_recap_imperfettivo_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 112777, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 111409, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 112662, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 107321, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104417, 85),
      ))
    }

@delegate:ResourceContentHash(1_307_610_146)
internal val Res.string.exp_content_recap_imperfettivo_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_recap_imperfettivo_alyn_2", "exp_content_recap_imperfettivo_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 112871, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 111495, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 112752, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 107407, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104503, 77),
      ))
    }

@delegate:ResourceContentHash(689_632_098)
internal val Res.string.exp_content_recap_imperfettivo_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_recap_imperfettivo_nilo_1", "exp_content_recap_imperfettivo_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 112969, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 111581, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 112838, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 107497, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104581, 77),
      ))
    }

@delegate:ResourceContentHash(1_390_729_854)
internal val Res.string.exp_content_recap_imperfettivo_zeta_1: StringResource by lazy {
      StringResource("string:exp_content_recap_imperfettivo_zeta_1", "exp_content_recap_imperfettivo_zeta_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 113063, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 111667, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 112932, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 107583, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104659, 117),
      ))
    }

@delegate:ResourceContentHash(1_433_992_503)
internal val Res.string.exp_content_recap_imperfettivo_zeta_2: StringResource by lazy {
      StringResource("string:exp_content_recap_imperfettivo_zeta_2", "exp_content_recap_imperfettivo_zeta_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 113197, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 111793, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 113058, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 107693, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104777, 65),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString9Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_content_possessivo_suffisso_11", Res.string.exp_content_possessivo_suffisso_11)
  map.put("exp_content_possessivo_suffisso_12", Res.string.exp_content_possessivo_suffisso_12)
  map.put("exp_content_possessivo_suffisso_13", Res.string.exp_content_possessivo_suffisso_13)
  map.put("exp_content_possessivo_suffisso_14", Res.string.exp_content_possessivo_suffisso_14)
  map.put("exp_content_possessivo_suffisso_15", Res.string.exp_content_possessivo_suffisso_15)
  map.put("exp_content_possessivo_suffisso_16", Res.string.exp_content_possessivo_suffisso_16)
  map.put("exp_content_possessivo_suffisso_17", Res.string.exp_content_possessivo_suffisso_17)
  map.put("exp_content_possessivo_suffisso_18", Res.string.exp_content_possessivo_suffisso_18)
  map.put("exp_content_possessivo_suffisso_19", Res.string.exp_content_possessivo_suffisso_19)
  map.put("exp_content_possessivo_suffisso_2", Res.string.exp_content_possessivo_suffisso_2)
  map.put("exp_content_possessivo_suffisso_20", Res.string.exp_content_possessivo_suffisso_20)
  map.put("exp_content_possessivo_suffisso_21", Res.string.exp_content_possessivo_suffisso_21)
  map.put("exp_content_possessivo_suffisso_3", Res.string.exp_content_possessivo_suffisso_3)
  map.put("exp_content_possessivo_suffisso_4", Res.string.exp_content_possessivo_suffisso_4)
  map.put("exp_content_possessivo_suffisso_5", Res.string.exp_content_possessivo_suffisso_5)
  map.put("exp_content_possessivo_suffisso_6", Res.string.exp_content_possessivo_suffisso_6)
  map.put("exp_content_possessivo_suffisso_7", Res.string.exp_content_possessivo_suffisso_7)
  map.put("exp_content_possessivo_suffisso_8", Res.string.exp_content_possessivo_suffisso_8)
  map.put("exp_content_possessivo_suffisso_9", Res.string.exp_content_possessivo_suffisso_9)
  map.put("exp_content_prendiamo_ad_esempio_la_frase_n_il_vino_del_p", Res.string.exp_content_prendiamo_ad_esempio_la_frase_n_il_vino_del_p)
  map.put("exp_content_preposizione_dr_1", Res.string.exp_content_preposizione_dr_1)
  map.put("exp_content_preposizione_dr_10", Res.string.exp_content_preposizione_dr_10)
  map.put("exp_content_preposizione_dr_11", Res.string.exp_content_preposizione_dr_11)
  map.put("exp_content_preposizione_dr_12", Res.string.exp_content_preposizione_dr_12)
  map.put("exp_content_preposizione_dr_2", Res.string.exp_content_preposizione_dr_2)
  map.put("exp_content_preposizione_dr_3", Res.string.exp_content_preposizione_dr_3)
  map.put("exp_content_preposizione_dr_4", Res.string.exp_content_preposizione_dr_4)
  map.put("exp_content_preposizione_dr_5", Res.string.exp_content_preposizione_dr_5)
  map.put("exp_content_preposizione_dr_6", Res.string.exp_content_preposizione_dr_6)
  map.put("exp_content_preposizione_dr_7", Res.string.exp_content_preposizione_dr_7)
  map.put("exp_content_preposizione_dr_7_zeta", Res.string.exp_content_preposizione_dr_7_zeta)
  map.put("exp_content_preposizione_dr_8", Res.string.exp_content_preposizione_dr_8)
  map.put("exp_content_preposizione_dr_9", Res.string.exp_content_preposizione_dr_9)
  map.put("exp_content_preposizione_hr_1", Res.string.exp_content_preposizione_hr_1)
  map.put("exp_content_preposizione_hr_10", Res.string.exp_content_preposizione_hr_10)
  map.put("exp_content_preposizione_hr_11", Res.string.exp_content_preposizione_hr_11)
  map.put("exp_content_preposizione_hr_12", Res.string.exp_content_preposizione_hr_12)
  map.put("exp_content_preposizione_hr_13", Res.string.exp_content_preposizione_hr_13)
  map.put("exp_content_preposizione_hr_14", Res.string.exp_content_preposizione_hr_14)
  map.put("exp_content_preposizione_hr_2", Res.string.exp_content_preposizione_hr_2)
  map.put("exp_content_preposizione_hr_3", Res.string.exp_content_preposizione_hr_3)
  map.put("exp_content_preposizione_hr_4", Res.string.exp_content_preposizione_hr_4)
  map.put("exp_content_preposizione_hr_5", Res.string.exp_content_preposizione_hr_5)
  map.put("exp_content_preposizione_hr_6", Res.string.exp_content_preposizione_hr_6)
  map.put("exp_content_preposizione_hr_7", Res.string.exp_content_preposizione_hr_7)
  map.put("exp_content_preposizione_hr_8", Res.string.exp_content_preposizione_hr_8)
  map.put("exp_content_preposizione_hr_9", Res.string.exp_content_preposizione_hr_9)
  map.put("exp_content_preposizione_m_1", Res.string.exp_content_preposizione_m_1)
  map.put("exp_content_preposizione_m_2", Res.string.exp_content_preposizione_m_2)
  map.put("exp_content_preposizione_m_3", Res.string.exp_content_preposizione_m_3)
  map.put("exp_content_preposizione_m_4", Res.string.exp_content_preposizione_m_4)
  map.put("exp_content_preposizione_m_5", Res.string.exp_content_preposizione_m_5)
  map.put("exp_content_preposizione_m_6", Res.string.exp_content_preposizione_m_6)
  map.put("exp_content_preposizione_m_7", Res.string.exp_content_preposizione_m_7)
  map.put("exp_content_preposizione_m_locativa_1", Res.string.exp_content_preposizione_m_locativa_1)
  map.put("exp_content_preposizione_m_locativa_10", Res.string.exp_content_preposizione_m_locativa_10)
  map.put("exp_content_preposizione_m_locativa_11", Res.string.exp_content_preposizione_m_locativa_11)
  map.put("exp_content_preposizione_m_locativa_12", Res.string.exp_content_preposizione_m_locativa_12)
  map.put("exp_content_preposizione_m_locativa_13", Res.string.exp_content_preposizione_m_locativa_13)
  map.put("exp_content_preposizione_m_locativa_14", Res.string.exp_content_preposizione_m_locativa_14)
  map.put("exp_content_preposizione_m_locativa_15", Res.string.exp_content_preposizione_m_locativa_15)
  map.put("exp_content_preposizione_m_locativa_2", Res.string.exp_content_preposizione_m_locativa_2)
  map.put("exp_content_preposizione_m_locativa_3", Res.string.exp_content_preposizione_m_locativa_3)
  map.put("exp_content_preposizione_m_locativa_4", Res.string.exp_content_preposizione_m_locativa_4)
  map.put("exp_content_preposizione_m_locativa_5", Res.string.exp_content_preposizione_m_locativa_5)
  map.put("exp_content_preposizione_m_locativa_6", Res.string.exp_content_preposizione_m_locativa_6)
  map.put("exp_content_preposizione_m_locativa_7", Res.string.exp_content_preposizione_m_locativa_7)
  map.put("exp_content_preposizione_m_locativa_8", Res.string.exp_content_preposizione_m_locativa_8)
  map.put("exp_content_preposizione_m_locativa_9", Res.string.exp_content_preposizione_m_locativa_9)
  map.put("exp_content_presto_al_prossimo_capitolo", Res.string.exp_content_presto_al_prossimo_capitolo)
  map.put("exp_content_prima_del_cartiglio_in_apposizione_si_trova_il_titolo", Res.string.exp_content_prima_del_cartiglio_in_apposizione_si_trova_il_titolo)
  map.put("exp_content_prima_di_addentrarci_nelle_regole_delle_frasi", Res.string.exp_content_prima_di_addentrarci_nelle_regole_delle_frasi)
  map.put("exp_content_prima_di_imparare_altre_parole_dobbiamo_capir", Res.string.exp_content_prima_di_imparare_altre_parole_dobbiamo_capir)
  map.put("exp_content_quando_la_cosa_posseduta_e_singolare_e_maschile_basta", Res.string.exp_content_quando_la_cosa_posseduta_e_singolare_e_maschile_basta)
  map.put("exp_content_quando_un_segno_usato_come_ideogramma_si_aggi", Res.string.exp_content_quando_un_segno_usato_come_ideogramma_si_aggi)
  map.put("exp_content_questa_pratica_era_molto_diffusa_come_offerta", Res.string.exp_content_questa_pratica_era_molto_diffusa_come_offerta)
  map.put("exp_content_questa_regola_ti_aiuta_a_leggere_subito_titoli_e_nomi", Res.string.exp_content_questa_regola_ti_aiuta_a_leggere_subito_titoli_e_nomi)
  map.put("exp_content_questa_scritta_sulla_mummia_illuminata", Res.string.exp_content_questa_scritta_sulla_mummia_illuminata)
  map.put("exp_content_questa_volta_sar_un_po_pi_difficile", Res.string.exp_content_questa_volta_sar_un_po_pi_difficile)
  map.put("exp_content_queste_due_parole_ad_esempio_contengono_le_st", Res.string.exp_content_queste_due_parole_ad_esempio_contengono_le_st)
  map.put("exp_content_questi_sono_fratelli_snu_e_sorelle_snut", Res.string.exp_content_questi_sono_fratelli_snu_e_sorelle_snut)
  map.put("exp_content_questi_sono_fratello_sn_e_sorella_snt", Res.string.exp_content_questi_sono_fratello_sn_e_sorella_snt)
  map.put("exp_content_questo_permetteva_di_ottimizzare_lo_spazio_a_", Res.string.exp_content_questo_permetteva_di_ottimizzare_lo_spazio_a_)
  map.put("exp_content_qui_oltre_a_ty_viene_ripetuto_due_volte_il_si", Res.string.exp_content_qui_oltre_a_ty_viene_ripetuto_due_volte_il_si)
  map.put("exp_content_qui_sempre_per_motivi_artistici_viene_anche_a", Res.string.exp_content_qui_sempre_per_motivi_artistici_viene_anche_a)
  map.put("exp_content_qui_stato_usato_il_plurale_normale_ma_il_dopp", Res.string.exp_content_qui_stato_usato_il_plurale_normale_ma_il_dopp)
  map.put("exp_content_quindi_il_genitivo_indiretto_cambia_in_base_al", Res.string.exp_content_quindi_il_genitivo_indiretto_cambia_in_base_al)
  map.put("exp_content_recap_frasi_pseudoverbali_1", Res.string.exp_content_recap_frasi_pseudoverbali_1)
  map.put("exp_content_recap_frasi_pseudoverbali_2", Res.string.exp_content_recap_frasi_pseudoverbali_2)
  map.put("exp_content_recap_frasi_pseudoverbali_3", Res.string.exp_content_recap_frasi_pseudoverbali_3)
  map.put("exp_content_recap_frasi_pseudoverbali_4", Res.string.exp_content_recap_frasi_pseudoverbali_4)
  map.put("exp_content_recap_frasi_pseudoverbali_5", Res.string.exp_content_recap_frasi_pseudoverbali_5)
  map.put("exp_content_recap_frasi_pseudoverbali_6", Res.string.exp_content_recap_frasi_pseudoverbali_6)
  map.put("exp_content_recap_frasi_pseudoverbali_7", Res.string.exp_content_recap_frasi_pseudoverbali_7)
  map.put("exp_content_recap_frasi_pseudoverbali_8", Res.string.exp_content_recap_frasi_pseudoverbali_8)
  map.put("exp_content_recap_imperfettivo_alyn_1", Res.string.exp_content_recap_imperfettivo_alyn_1)
  map.put("exp_content_recap_imperfettivo_alyn_2", Res.string.exp_content_recap_imperfettivo_alyn_2)
  map.put("exp_content_recap_imperfettivo_nilo_1", Res.string.exp_content_recap_imperfettivo_nilo_1)
  map.put("exp_content_recap_imperfettivo_zeta_1", Res.string.exp_content_recap_imperfettivo_zeta_1)
  map.put("exp_content_recap_imperfettivo_zeta_2", Res.string.exp_content_recap_imperfettivo_zeta_2)
}
